import { useState } from "react";
import { ImageField } from "./ImageField";

const toForm = (fields, item) =>
  Object.fromEntries(fields.map((f) => {
    const v = item[f.name] ?? f.default ?? (f.type === "checkbox" ? false : "");
    return [f.name, f.type === "list" ? (v || []).join(", ") : v];
  }));

export const ItemForm = ({ fields, item, label, onSave, onCancel, testid }) => {
  const [form, setForm] = useState(() => toForm(fields, item));
  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    const body = { ...form };
    fields.forEach((f) => {
      if (f.type === "number") body[f.name] = Number(body[f.name]);
      if (f.type === "list") body[f.name] = String(body[f.name]).split(",").map((s) => s.trim()).filter(Boolean);
    });
    const missingImg = fields.find((f) => f.type === "image" && f.required && !body[f.name]);
    if (missingImg) return alert(`Please upload ${missingImg.label.toLowerCase()}`);
    onSave(body);
  };

  return (
    <form onSubmit={submit} data-testid={testid} className="card-surface rounded-2xl p-6 grid sm:grid-cols-2 gap-5">
      <h3 className="sm:col-span-2 font-cond uppercase font-bold text-2xl">{item.id ? "Edit" : "New"} {label}</h3>
      {fields.map((f) => (
        <div key={f.name} className={f.type === "textarea" || f.type === "image" ? "sm:col-span-2" : ""}>
          {f.type !== "checkbox" && <label className="block font-cond uppercase tracking-widest text-xs text-slate-400 mb-2">{f.label}{f.required && " *"}</label>}
          {f.type === "image" ? (
            <ImageField value={form[f.name]} onChange={(v) => set(f.name, v)} testid={`${testid}-${f.name}`} />
          ) : f.type === "textarea" ? (
            <textarea rows={3} className="field" value={form[f.name]} onChange={(e) => set(f.name, e.target.value)} data-testid={`${testid}-${f.name}`} />
          ) : f.type === "checkbox" ? (
            <label className="flex items-center gap-3 text-sm text-slate-300 mt-6">
              <input type="checkbox" checked={!!form[f.name]} onChange={(e) => set(f.name, e.target.checked)} data-testid={`${testid}-${f.name}`} className="accent-[#00d436] w-4 h-4" /> {f.label}
            </label>
          ) : (
            <input type={f.type === "list" ? "text" : f.type || "text"} step={f.step} min={f.type === "number" ? 0 : undefined} required={f.required}
              className="field" value={form[f.name]} onChange={(e) => set(f.name, e.target.value)} data-testid={`${testid}-${f.name}`} />
          )}
        </div>
      ))}
      <div className="sm:col-span-2 flex gap-3">
        <button type="submit" data-testid={`${testid}-save`} className="btn-lime rounded-full px-8 py-3 font-cond uppercase font-bold tracking-widest">Save</button>
        <button type="button" onClick={onCancel} data-testid={`${testid}-cancel`} className="btn-line rounded-full px-6 py-3 font-cond uppercase tracking-widest">Cancel</button>
      </div>
    </form>
  );
};
